import React from "react";
import {
  CONFIGURATION_LINK_CONFIGURATION_PATH,
  CONFIGURATION_LINK_APPEARANCE_PATH,
  CONFIGURATION_LINK_BRANDING_PATH,
} from "../../../../router/RouterUtils";
import SubLeftNavigationContainer from "../../../portal/SubLeftNavigationContainer";
import useProductRestrictions from "../../../shared/hooks/useProductRestrictions";

/**
 * Creates a wrapper for the Link configurations page
 */
const ConfigurationLinkPageWrapper = ({
  children,
}: Pick<React.ComponentProps<"div">, "children">) => {
  const { productRestrictions } = useProductRestrictions();

  const customizableLinkEnabled = productRestrictions?.customizable_link_enabled;

  const customizableLinkSubtabs = [
    {
      label: "Appearance",
      destination: CONFIGURATION_LINK_APPEARANCE_PATH,
      isBeta: false,
    },
    {
      label: "Configuration",
      destination: CONFIGURATION_LINK_CONFIGURATION_PATH,
    },
    {
      label: "Branding",
      destination: CONFIGURATION_LINK_BRANDING_PATH,
      isBeta: true,
    },
  ];

  const subtabs = [
    {
      label: "Configuration",
      destination: CONFIGURATION_LINK_CONFIGURATION_PATH,
    },
  ];

  return (
    <SubLeftNavigationContainer
      subtabs={customizableLinkEnabled ? customizableLinkSubtabs : subtabs}
    >
      {children}
    </SubLeftNavigationContainer>
  );
};

export default ConfigurationLinkPageWrapper;
